import React from 'react';

const RESOURCES = [
    { kind: 'RESOURCE', title: 'Sample IC memo', body: 'An anonymized investment committee memo produced from a live deal. Shows exactly what you receive and to what standard.', cta: 'Download PDF' },
    { kind: 'RESOURCE', title: 'AI deal-sourcing guide', body: 'How we build proprietary origination pipelines across web, filings and trade sources, and verify every signal before it reaches you.', cta: 'Download PDF' },
    { kind: 'TOOL', title: 'LP Scouting Tool', body: 'A basic version, free for PE and VC firms. Identify and shortlist limited partners that fit your fund profile, then take the shortlist straight into outreach.', cta: 'Open Tool' },
];

const PEResourcesSection = () => (
    <section className="lp-pe-resources">
        <div className="lp-pe-wrap">
            <div className="lp-pe-resources-head">
                <h2 className="lp-pe-h2 is-dark" data-lp-reveal>Free Resources &amp; Tools</h2>
                <p data-lp-reveal data-lp-delay="80">Three resources showing how we source, screen and diligence deals.</p>
            </div>
            <div className="lp-pe-resources-grid">
                {RESOURCES.map((r, i) => (
                    <div className="lp-pe-resource" key={r.title} data-lp-reveal data-lp-delay={i * 80}>
                        <div className="lp-pe-resource-top">
                            <span className="lp-pe-resource-kind">{r.kind}</span>
                            <span className="lp-pe-resource-badge">
                                <img src={require('../../../../images/landing-pages/PE/morsebridge-icon.png')} alt="" />MORSEBRIDGE
                            </span>
                        </div>
                        <h3 className='w100'>{r.title}</h3>
                        <p>{r.body}</p>
                        {/* Reason: href left as a placeholder — the design ships no asset URLs for these. */}
                        <a className="lp-pe-btn lp-pe-btn--purple" href="#">{r.cta}</a>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default PEResourcesSection;
